module.exports = __webpack_public_path__ + "img/48.baf9bf12.jpg";